<vi-card data-at-dialog [dialog]="true">
  <h2 title data-at-title>
    {{ '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.TITLE' | translate }}
  </h2>
  <div body class="flex flex-col gap-[20px] justify-center items-start">
    <mat-radio-group [(ngModel)]="selectedHolidayType">
      <vi-radio-button
        value="{{ holidayProgramType.HOLIDAY }}"
        gtm="onSelect"
        gtmAction="Holiday program"
        gtmCategory="holidayProgram"
        [label]="
          '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.SELECT.HOLIDAY_PROGRAM' | translate
        "
        [checked]="false"
      ></vi-radio-button>
      <vi-radio-button
        value="{{ holidayProgramType.HOLIDAY_AT_HOME }}"
        gtm="onSelect"
        gtmAction="Holiday at home"
        gtmCategory="holidayProgram"
        [label]="
          '+INSTALLATIONS.INSTALLATION.HOLIDAY_MODE.DIALOG.SELECT.HOLIDAY_AT_HOME' | translate
        "
        [checked]="false"
      ></vi-radio-button>
    </mat-radio-group>
  </div>
  <div
    footer
    data-at-footer
    class="flex flex-row xs:flex-col-reverse gap-[8px] justify-between items-stretch flex-auto"
  >
    <button
      data-at-cancel-btn
      mat-button
      color="primary"
      gtm="onActivateHolidayProgramNo"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-change-btn
      mat-raised-button
      color="primary"
      [disabled]="!selectedHolidayType"
      gtm="onNextStep"
      gtmCategory="holidayProgram"
      (click)="goToNextStage()"
    >
      {{ 'GENERAL.BUTTON.NEXT' | translate }}
    </button>
  </div>
</vi-card>
